module.exports = __webpack_public_path__ + "static/media/b0_p11_scout_01.f7509484.mp3";